import { render, staticRenderFns } from "./opt_color_labels.vue?vue&type=template&id=3de42a3a&scoped=true&lang=html"
import script from "./opt_color_labels.vue?vue&type=script&lang=js"
export * from "./opt_color_labels.vue?vue&type=script&lang=js"
import style0 from "./opt_color_labels.vue?vue&type=style&index=0&id=3de42a3a&prod&scoped=true&lang=css"
import style1 from "./opt_color_labels.vue?vue&type=style&index=1&id=3de42a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de42a3a",
  null
  
)

export default component.exports